import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    marginTop: 12,
    flex: 1,
    maxWidth: 900,
    flexDirection: "column",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    padding: 12,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  inputContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },

  btnContainer: {
    flexWrap: "wrap",
    marginTop: 10,
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-evenly",
  },

  actionButton: {
    flex: 1,
    padding: 10,
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    backgroundColor: "#077A97",
    justifyContent: "space-between",
    paddingVertical: 8,
    maxWidth: 140,
    minWidth: 140,
    marginBottom: 8,
    marginHorizontal: 10,
    flexWrap: "wrap",
  },

  goBackBtn: {
    flex: 1,
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    backgroundColor: "#fff",
    justifyContent: "space-between",
    paddingVertical: 8,
    maxWidth: 140,
    minWidth: 140,
    marginBottom: 8,
    marginHorizontal: 10,
    flexWrap: "wrap",
  },

  goBackBtnText: {
    color: "#077A97",
    letterSpacing: 1,
    fontSize: 16,
  },

  actionButtonText: {
    letterSpacing: 1,
    color: "#FFFFFF",
    fontSize: 16,
  },
});
